export const translations = {
  en: {
    title: 'Patient Information Summary',
    header_patient: 'Patient Information',
    label_name: 'Patient Legal Name: ',
    label_phone: 'Patient Phone: ',
    label_alt_phone: 'Patient Alt Phone: ',
    label_email: 'Patient Email: ',
    label_birthdate: 'Patient Legal Birthdate: ',
    label_sex: 'Patient sex: ',
    label_address: 'Patient Address: ',
    label_have_insurance: 'Do you have insurance? ',
    label_change_insurance: 'Need to change insurance? ',
    label_seen_intermountain: 'Have you been seen at Intermountain? ',
    header_insurance: 'Insurance Information',
    label_plan: 'Plan Network: ',
    label_plan_address: 'Health Plan Address: ',
    label_member_id: 'Member Number/ID: ',
    label_group_id: 'Group Number/ID: ',
    header_subscriber: 'Subscriber Information',
    label_relationship: 'Patient Relationship to subscriber: ',
    label_subscriber_name: "Subscriber's Legal Name: ",
    label_subscriber_phone: "Subscriber's Phone: ",
    label_subscriber_birthdate: "Subscriber's Legal Birthdate: ",
    label_subscriber_email: "Subscriber's Legal Email: ",
    label_subscriber_sex: "Subscriber's Sex: ",
    label_subscriber_address: "Subscriber's Address: ",
    paragraph:
      'If you would like to change any of the information above, please click the previous button. If all information looks correct, click submit to confirm your order and see a list of available testing sites.'
  },
  es: {
    title: 'Resumen de la información del paciente',
    header_patient: 'Información del paciente',
    label_name: 'Nombre legal del paciente: ',
    label_phone: 'Teléfono del paciente: ',
    label_alt_phone: 'Teléfono alternativo del paciente: ',
    label_email: 'Email del paciente: ',
    label_birthdate: 'Fecha de nacimiento legal del paciente: ',
    label_sex: 'Sexo del paciente: ',
    label_address: 'Dirección del paciente: ',
    label_have_insurance: '¿Tiene seguro médico? ',
    label_change_insurance: '¿Necesita cambiar su seguro? ',
    label_seen_intermountain: '¿Ha sido tratado en Intermountain? : ',
    header_insurance: 'Información del seguro',
    label_plan: 'Nombre del plan de salud: ',
    label_plan_address: 'Dirección del seguro médico: ',
    label_member_id: 'Número/ID de miembro: ',
    label_group_id: 'ID/Número de grupo: ',
    header_subscriber: 'Información del suscriptor del plan de salud',
    label_relationship: 'Relación con el suscriptor: ',
    label_subscriber_name: 'Nombre legal del suscriptor: ',
    label_subscriber_phone: 'Teléfono del suscriptor: ',
    label_subscriber_birthdate: 'Fecha de nacimiento legal del suscriptor: ',
    label_subscriber_email: 'Email legal del subscriptor: ',
    label_subscriber_sex: 'Sexo del suscriptor: ',
    label_subscriber_address: 'Dirección del suscriptor: ',
    paragraph:
      'Si quiere corregir o cambiar la información provista, use el botón atrás (Anterior). Si toda la información aparece correctamente, haga clic en enviar para confirmar su pedido y ver una lista de centros de pruebas disponibles.'
  }
};
